import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  FaConfig,
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import {
  faBook,
  faGlassCheers,
  faHandScissors,
  faTasks,
  faWineBottle,
} from '@fortawesome/free-solid-svg-icons';
import { faBeer } from '@fortawesome/free-solid-svg-icons/faBeer';
import { faCampground } from '@fortawesome/free-solid-svg-icons/faCampground';
import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons/faPeopleGroup';
import {
  IonApp,
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';

import { FabContactComponent } from '../../../common/components/fab-contact/fab-contact.component';
import { ProgressBarComponent } from '../../../common/components/progress-bar/progress-bar.component';
import { SwitchThemeButtonComponent } from '../../../common/components/switch-theme-button/switch-theme-button.component';
import { PwaService } from '../../../common/services/pwa.service';
import { environment } from '../environments/environment';
import { fontAwesomeIcons, ionicIcons } from './icons.const';

@Component({
  selector: 'fal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonApp,
    ProgressBarComponent,
    IonSplitPane,
    IonMenu,
    IonHeader,
    IonToolbar,
    IonTitle,
    SwitchThemeButtonComponent,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonMenuToggle,
    IonItem,
    FaIconComponent,
    IonLabel,
    IonFooter,
    IonRouterOutlet,
    FabContactComponent,
    RouterLink,
    AsyncPipe,
    RouterLinkActive,
  ],
})
export class AppComponent {
  public readonly showFabContactButtons =
    !environment.featureFlipping.contactFabButton;
  public readonly environment = environment;
  public readonly faGlassCheers = faGlassCheers;
  public readonly faBook = faBook;
  public readonly faTasks = faTasks;
  public readonly faWineBottle = faWineBottle;
  public readonly faHandScissors = faHandScissors;
  protected readonly faPeopleGroup = faPeopleGroup;
  protected readonly faCampground = faCampground;
  protected readonly faBeer = faBeer;
  private readonly faIconLibrary = inject(FaIconLibrary);
  private readonly faConfig = inject(FaConfig);
  private readonly pwaService = inject(PwaService);

  constructor() {
    addIcons(ionicIcons);
    this.pwaService.init();
    this.faConfig.defaultPrefix = 'fas';
    this.faConfig.fallbackIcon = faBook;
    this.faIconLibrary.addIcons(...fontAwesomeIcons);
  }
}
